<template>
  <v-dialog
    v-model="show"
    max-width="700"
    persistent
  >
    <v-card flat>
      <v-toolbar
        color="primary"
        dark
        flat
      >
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer />
        <v-btn
          @click="close"
          icon
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-4">
        <div
          v-for="(period, index) in periods"
          :key="index"
          class="period-item"
        >
          <div class="period-date-header">
            Período: {{ formatPeriodDate(period.startDate) }} à {{ formatPeriodDate(period.endDate) }}
          </div>
          <AppTable
            :headers="getPeriodTableHeaders()"
            :items="[{ ...period, _id: period._id || `period-${index}` }]"
            hide-title
            class="period-table"
          />
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import AppTable from '@/components/ui/AppTable.vue'

export default {
  name: 'PeriodsModal',
  components: {
    AppTable
  },
  data: () => ({
    show: false,
    title: '',
    periods: []
  }),
  methods: {
    open({ companyName, periods }) {
      this.title = `Períodos - ${companyName}`
      this.periods = periods || []
      this.show = true
    },
    close() {
      this.show = false
      this.periods = []
      this.title = ''
    },
    formatPeriodDate(date) {
      if (!date) return '-'
      return this.$date(date)
    },
    formatCurrency(value) {
      if (value === null || value === undefined) return '0'
      return this.$currencyFormat(value)
    },
    getPeriodTableHeaders() {
      return [
        {
          text: 'Aprovação final',
          value: 'approvalStatus',
          sortable: false,
          formatter: (period) => period.approvalStatus || 'Pendente'
        },
        {
          text: 'Total (Bruto)',
          value: 'grossTotal',
          sortable: false,
          formatter: (period) => this.formatCurrency(period.grossTotal)
        },
        {
          text: 'Diferença',
          value: 'difference',
          sortable: false,
          formatter: (period) => this.formatCurrency(period.difference)
        },
        {
          text: 'Total (A pagar)',
          value: 'totalToScore',
          sortable: false,
          formatter: (period) => this.formatCurrency(period.totalToScore)
        },
        {
          text: 'Total (Pago)',
          value: 'paidTotal',
          sortable: false,
          formatter: (period) => this.formatCurrency(period.paidTotal)
        }
      ]
    }
  }
}
</script>

<style lang="stylus" scoped>
.period-item {
  padding: 0;
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.period-date-header {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5;
  color: #001648;
  background-color: #DEE7E6;
  padding: 8px 16px;
  border-radius: 4px 4px 0 0;
  margin-bottom: 0;
}
</style>

